import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';

import ChatService from 'services/ChatService';
import AuthService from 'services/AuthService';
import { Text } from 'components/FormElements';
import { toggleAlertError, toggleLoading, changeStatusWebsocket, sendMessageWebsocket } from 'stores/actions';
import Dropzone from "react-dropzone";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import _ from "lodash";
import classnames from "classnames";
import CircularProgress from "material-ui/CircularProgress";

class Websocket extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      messagesDate: null,
    };
    this.messages = []
  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.newMessageDataDate && this.props.newMessageDataDate !== nextProps.newMessageDataDate ) {
      this.messages = [...this.messages, nextProps.newMessageData];
      this.setState( { messagesDate: new Date().valueOf() } )
    }

    if( nextProps.newMessageFileDataDate && this.props.newMessageFileDataDate !== nextProps.newMessageFileDataDate ) {
      if( _.get( nextProps, 'newMessageFileData.ref' ) && !_.get( nextProps, 'newMessageFileData.id' ) ) {
        if( _.get( nextProps, 'newMessageFileData.status' ) === 'ERROR' ) {
          const itemIndex = _.findIndex( this.messages, { ref: nextProps.newMessageFileData.ref } );
          if( itemIndex !== -1 ) {
            this.messages[itemIndex] = nextProps.newMessageFileData;
            this.setState( { messagesDate: new Date().valueOf() } )
          }
        } else {
          this.messages = [...this.messages, nextProps.newMessageFileData];
          this.setState( { messagesDate: new Date().valueOf() } )
        }
      }

      if( _.get( nextProps, 'newMessageFileData.ref' ) && _.get( nextProps, 'newMessageFileData.id' ) ) {
        const itemIndex = _.findIndex( this.messages, { ref: nextProps.newMessageFileData.ref } );
        if( itemIndex !== -1 ) {
          this.messages[itemIndex] = nextProps.newMessageFileData;
          this.setState( { messagesDate: new Date().valueOf() } )
        }
      }
    }
  }

  sendTextMessage = ( data ) => {
    const { sendMessageWebsocket } = this.props;
    if( data.message && data.message.trim() ) {
      sendMessageWebsocket( {
        message: data.message,
        date: new Date().valueOf()
      } );
      this.setValue( 'message', null );
    }
  };

  sendFileMessage = ( file ) => {
    const { topicId, toggleLoading } = this.props;
    toggleLoading( true );

    const ref = uuidv4();
    ChatService.sendClientFile( { file, ref, topicId }, this.accessToken ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) {
        console.log( 'Upload Error', response.errors )
      }
    } )
  }

  initChat = ( data ) => {
    const { toggleAlertError, toggleLoading, changeStatusWebsocket, websocketStatus } = this.props;

    if( websocketStatus === 'off' ) {
      toggleLoading( true );

      AuthService.loginClient().then( ( response ) => {
        if( response.errors ) {
          toggleLoading( false );
          return toggleAlertError( response.errors );
        }

        this.accessToken = response.data.access_token;
        ChatService.getClientCredentials( data, response.data.access_token ).then( ( response ) => {
          toggleLoading( false );
          if( response.errors ) return toggleAlertError( response.errors );

          changeStatusWebsocket( {
            status: 'on',
            data: response.data
          } )
        } )
      } )
    } else {
      changeStatusWebsocket( { status: 'off' } )
    }
  };

  render() {
    const { websocketStatus } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="card bg-white">
              <div className="card-content">
                <Form onSubmit={this.initChat}>
                  {( { submitForm } ) =>
                    <form onSubmit={submitForm}>
                      <div className="form-group mt-3">
                        <Text field="name" placeholder="name" className="form-control"/>
                        <Text field="email" placeholder="email" className="form-control mt-2"/>
                        <Text field="subject" placeholder="subject" className="form-control mt-2"/>
                      </div>

                      <div className="text-right mt-3">
                        <button className="btn btn-info text-uppercase mr-2">
                          {websocketStatus === 'on' ? 'Disconnect' : 'Connect'}
                        </button>
                      </div>
                    </form>
                  }
                </Form>
              </div>
            </div>

            {websocketStatus === 'on' &&
            <div className="card bg-white">
              <div className="card-content">
                <Form onSubmit={this.sendTextMessage}>
                  {( { submitForm, setValue } ) => {
                    this.setValue = setValue;
                    return (
                      <form onSubmit={submitForm}>
                        <div className="form-group mt-3">
                          <Text field="message" className="form-control"/>
                        </div>

                        <div className="text-right mt-3">
                          <Dropzone
                            className="dropzone pointer col-auto px-2 d-flex align-items-center"
                            accept="image/*,.doc,.docx,.pdf"
                            maxSize={1000000}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                  this.sendFileMessage( files[0] )
                                };
                                reader.readAsDataURL( files[0] );
                              }
                            }}
                          >
                            <i className="icon-attachment text-info" style={{ fontSize: '18px' }}/>
                          </Dropzone>
                          <button type="submit" className="btn btn-info text-uppercase">
                            Send
                          </button>
                        </div>
                      </form>
                    )
                  }}
                </Form>
              </div>
            </div>
            }
          </div>

          <div className="col-md-6">
            {_.map( this.messages, message => (
              <div
                key={message.id}
                className={classnames( {
                  'chat-messages-message-right mr-3': !message.agent,
                  'chat-messages-message-left': message.agent,
                } )}
              >
                <div className="chat-messages-message-container">
                  <div className="row no-gutters align-items-center">
                    <div className="col order-1 order-sm-0">
                      <div className="chat-messages-message-content">
                        {( !!message.webPathFileName )
                        && (
                          <div className="col-xs-12 chat-messages-message-image">
                            <a href={message.webPathFileName} target="_blank">
                              {_.startsWith( message.mimeType, 'image/' ) ?
                                <img
                                  alt="..."
                                  src={message.webPathFileName}
                                />
                                : <i className={classnames( 'fa fa-file-archive-o fa-2x', {
                                  'color-white': !!message.agent
                                } )}/>}
                            </a>
                          </div>
                        )}
                        {!!message.body
                        && (
                          <div className="col-xs-12 chat-messages-message-text">
                            <span>{message.body}</span>
                          </div>
                        )}
                        <div className="col-xs-12 chat-messages-message-time">
                          <span>{moment( Number( `${message.createdAt}000` ) ).format( 'h:mm A' )}</span>
                          {message.type === 'file' && !message.id && message.status !== 'ERROR' &&
                          <span className="ml-2"><CircularProgress color="white" size={20} thickness={3}/></span>}
                          {message.status === 'ERROR' &&
                          <i className="fa fa-exclamation-circle text-danger ml-2" style={{ fontSize: '18px' }}/>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ( state ) => ( {
  websocketStatus: state.websocket.status,
  topicId: _.get( state.websocket, 'data.topicId' ),
  newMessageData: state.websocket.newMessageData,
  newMessageDataDate: state.websocket.newMessageDataDate,
  newMessageFileData: state.websocket.newMessageFileData,
  newMessageFileDataDate: state.websocket.newMessageFileDataDate,
} );

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  changeStatusWebsocket: ( status ) => {
    dispatch( changeStatusWebsocket( status ) );
  },
  sendMessageWebsocket: ( data ) => {
    dispatch( sendMessageWebsocket( data ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Websocket );



// WEBPACK FOOTER //
// ./routes/app/routes/websocket/index.js